export type EHotjarEventType = 'success' | 'error' | 'warning';

export enum IHotjarEventType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning'
}

export enum IHotjarEventDescritpion {
  TOAST = 'toast_message',
  IMG_MISSING = 'image_missing',
  MAINTANCE_PAGE = 'maintance_page'
}
export interface HotjarSendApiEvent {
  typeEvent: EHotjarEventType;
  methodRequest: string;
  hostApiRequest: string;
  pathnameApiRequest: string;
}
export interface HotjarSendEventByTypeAndDescription {
  typeEvent: EHotjarEventType;
  description: IHotjarEventDescritpion;
}
export interface blockOriginPathUser {
  types: Array<EHotjarEventType>;
  methods: Array<string>;
  originPath: string;
}

export const formMethodsHotjarEvent: Array<string> = ['POST', 'PUT'];

export const apisTrackHotjarEvent = [
  process.env.VUE_APP_API_URL,
  process.env.VUE_APP_SERVICES_URL
].map(url => new URL(url!).hostname);

/* Path of blocked requests directly in the api */
export const blockListApiRequestPaths = ['/auth/token/refresh'];

/* Path of requests blocked by the request origin path (user url) */
export const blockListOriginPathUser: Array<blockOriginPathUser> = [
  {
    types: [IHotjarEventType.SUCCESS],
    methods: [...formMethodsHotjarEvent, 'PATCH'],
    originPath: '/new-onboarding'
  }
];
